import { pickClubEmployeeUserId } from "./clubEmployeeList";

/** Mongo user _id for POST .../resend-invite/:userId */
export function pickClubStaffUserId(row) {
  if (!row || typeof row !== "object") return "";
  const u = row.user;
  if (u && typeof u === "object") {
    const id = u._id ?? u.id;
    if (id != null && id !== "") return String(id);
  }
  if (row.userId != null && row.userId !== "") return String(row.userId);
  if (row.userid != null && row.userid !== "") return String(row.userid);
  if (row._id != null && row._id !== "" && (row.email || row.inviteStatus)) {
    return String(row._id);
  }
  return pickClubEmployeeUserId(row);
}

export function canShowResendInvite(row) {
  if (!row || typeof row !== "object") return false;
  if (row.canResendInvite === false) return false;
  const status = String(row.inviteStatus ?? "").trim().toUpperCase();
  if (status === "ACTIVE") return false;
  if (row.canResendInvite === true) return true;
  if (row.invitePending === true) return true;
  if (status === "INVITED") return true;
  return false;
}

export function pickInviteStatusKey(row) {
  const status = String(row?.inviteStatus ?? "").trim().toUpperCase();
  if (status === "INVITED" || status === "ACTIVE") return status;
  if (row?.invitePending === true) return "INVITED";
  if (row?.canResendInvite === true) return "INVITED";
  if (row?.hasSetPassword === true) return "ACTIVE";
  return "";
}

export function pickStaffEmail(row) {
  if (!row || typeof row !== "object") return "";
  return String(row.email ?? row.user?.email ?? "").trim();
}
